module.exports = __webpack_public_path__ + "static/media/team-3.993f587d.jpg";